$( document ).ready(function() {
	var $input = $("#bravo_nominees_search");

	var options = {
		theme: "blue-light",
		getValue: "name",
		url: function(phrase) {
			return "/bravo_nominees/search.json?q=" + phrase;
		},
		categories: [
			{
				listLocation: "employees"
				//header: "<strong>Employees</strong>"
			}
		],
		list: {
			onChooseEvent: function() {
				var url = $input.getSelectedItemData().url
				$input.val("")
				window.location = (url)
			}
		}
	};

	$input.easyAutocomplete(options);
});
